import { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { Spine } from '../spine';

// RU: огненная сцена телефона — спайн `mainBg` frame-пака поверх спрайтового фона ядра
//     (`bgConfigs.type: 'sprite'`, кадр `background` атласа игры). Мобильный `mainBg` — только огонь
//     (BgVFX и вспышки), без картинки: в 2.x картинку рисовал спрайт ядра, а этот спайн крутил петлю
//     `animation` поверх неё. На вебе `mainBg` — вся сцена, её рисует ядро (`type: 'spine'`), и этот
//     компонент там не монтируется. Декор: из хит-теста выведен — под `'static'`-корнем он забирал бы
//     нажатия.
export const WildFireScene = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const spine = new Spine({ key: 'mainBg' });
    spine.position.set(270, 480);
    spine.play('animation', true);
    containerRef.current.addChild(spine);
    return () => {
      if (!spine.destroyed) spine.destroy({ children: true });
    };
  }, []);

  return <Container ref={containerRef} eventMode='none' name='WildFireScene' />;
};
